import { useEffect } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "recompose";

import {
  NotifierProvider,
  PROJECT_NAME,
  Provider,
} from "@dpdgroupuk/mydpd-app";
import { Provider as ChatProvider } from "@dpdgroupuk/cc-chat-fe";
import "@dpdgroupuk/cc-chat-fe/dist/components/ChatBotApp.css";
import { Layout, Loader } from "@dpdgroupuk/mydpd-ui";

import { apisClient } from "./apis";
import Footer from "./Footer";
import Header from "./Header";
import { UmsActions } from "./redux";
import { Routes } from "./router";
import tracker from "./tracker";

import "./sentry";
import { CHAT_CONFIG } from "./constants/config";

const resetLocationHistory = () => {
  window.history.replaceState({}, document.title);
};

function App({ fetchInitialUmsData, verifyTrackingAccess }) {
  useEffect(() => {
    resetLocationHistory();

    window.addEventListener("beforeunload", resetLocationHistory);

    return () => {
      window.removeEventListener("beforeunload", resetLocationHistory);
    };
  }, []);

  return (
    <Provider
      errorTooltip
      projectName={PROJECT_NAME.DELIVERIES}
      apis={apisClient}
      tracker={tracker}
    >
      <Loader loadFn={fetchInitialUmsData}>
        <ChatProvider chatConfig={CHAT_CONFIG}>
          <Layout header={<Header />} footer={<Footer />}>
            <Loader loadFn={verifyTrackingAccess}>
              <NotifierProvider>
                <Routes />
              </NotifierProvider>
            </Loader>
          </Layout>
        </ChatProvider>
      </Loader>
    </Provider>
  );
}

App.propTypes = {
  fetchInitialUmsData: PropTypes.func,
  verifyTrackingAccess: PropTypes.func,
};

const mapDispatchToProps = {
  fetchInitialUmsData: UmsActions.fetchInitialUmsData,
  verifyTrackingAccess: UmsActions.verifyTrackingAccess,
};

export default compose(connect(null, mapDispatchToProps))(App);
